import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { getDateUtc } from '@wz-utilities/date.utilities';
import { WzDateValidators } from '@wz-validators';
import { addDays, addMonths, isBefore, isSameDay } from 'date-fns';
import { AppConstants } from 'libs/constants/app-constants';
import { FormGroupBaseComponent } from 'libs/modules/tunnelsante-forms/components/form-group-base.component';
import { QuotationModels } from 'models/quotation.models';
import { debounceTime, filter } from 'rxjs/operators';

@Component({
  selector: 'wz-car-quotation-subscription-form',
  templateUrl: './car-quotation-subscription-form.component.html',
  styleUrls: ['./car-quotation-subscription-form.component.scss'],
  standalone: false,
})
export class CarQuotationSubscriptionFormComponent
  extends FormGroupBaseComponent<QuotationModels.SubscriptionInfo>
  implements OnChanges
{
  @Input() policyCreationDate!: Date;

  @Output() effectDateChange = new EventEmitter<Date>();

  // public immatriculation: FormControl;
  public dateEffet: FormControl;

  constructor(private fb: FormBuilder) {
    super();

    this.buildForm();
    // this.immatriculation = this.formGroup.get('immatriculation') as FormControl;
    this.dateEffet = this.formGroup.get('dateEffet') as FormControl;
    this.dateEffet.valueChanges
      .pipe(
        debounceTime(AppConstants.Delay.VeryFast),
        filter(() => this.dateEffet.valid),
      )
      .subscribe((val: string) => {
        const date = getDateUtc(val);
        if (date) {
          this.effectDateChange.next(date);
        }
      });
  }

  ngOnChanges(change: SimpleChanges) {
    if (change['policyCreationDate']) {
      this.dateEffet.updateValueAndValidity();
    }
  }

  private buildForm() {
    const minDateFunc = (d: any) => {
      const min = this.policyCreationDate || getDateUtc();
      return isSameDay(d, min) || isBefore(min, d);
    };

    const maxDateFunc = (d: any) => {
      const max = addDays(
        addMonths(this.policyCreationDate || getDateUtc(), 1),
        5,
      );
      return isSameDay(d, max) || isBefore(d, max);
    };

    this.formGroup = this.fb.group({
      // immatriculation: this.fb.control('', [
      //     Validators.required,
      //     Validators.pattern(RegexConstants.CarImmatriculation)
      // ]),
      dateEffet: this.fb.control('', [
        Validators.required,
        WzDateValidators.invalid(),
        WzDateValidators.filter(minDateFunc, 'min'),
        WzDateValidators.filter(maxDateFunc, 'max'),
      ]),
    });
  }
}
